export const getValidUrl = (website: string) => {
  try {
    // Add protocol if missing
    const url = website.startsWith('http') ? website : `https://${website}`;
    return new URL(url);
  } catch (e) {
    return null;
  }
};